import map from 'lodash/map';
import reduce from 'lodash/reduce';
import { v4 as uuidv4 } from 'uuid';

export const toFalsyMap = (ids: string[]) =>
  reduce(
    ids,
    (acc: Record<string, boolean>, id) => {
      acc[id] = false;
      return acc;
    },
    {}
  );

export const toTruthyMap = <T>(ids: T[]) =>
  reduce(
    ids,
    (acc: Record<string, boolean>, id) => {
      acc[String(id)] = true;
      return acc;
    },
    {}
  );

export function toTruthyMapByKey<T extends Record<string, any>>(
  data: T[],
  key: keyof T
): Record<string, boolean> {
  return reduce(
    data,
    (acc: Record<string, boolean>, item) => {
      const value = item[key];
      if (value) {
        acc[String(value)] = true;
      }
      return acc;
    },
    {}
  );
}
export const sumArrays = (arr1: number[], arr2: number[]) => {
  const maxLength = Math.max(arr1.length, arr2.length);
  const result = [];
  for (let i = 0; i < maxLength; i++) {
    const sum = (arr1[i] || 0) + (arr2[i] || 0);
    result.push(sum);
  }
  return result;
};

export function sanitizeAndTokenize(input: string) {
  if (!input) {
    return [];
  }
  const sanitized = input
    .normalize('NFD') // Normalize to decompose accents and diacritics
    .replace(/[\u0300-\u036f]/g, '') // Remove accents and diacritical marks
    .replace(/[^\w\s]/g, '') // Remove special characters
    .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
    .trim() // Remove leading and trailing whitespace
    .toLowerCase(); // Convert to lowercase
  return sanitized.split(' '); // Split into an array of words
}

export const ifValue = <T>(cond: boolean = false, item: T) => {
  if (cond) {
    return item as T;
  }
  return {} as T;
};

export const ifItem = <T>(cond: boolean = false, item: T) => {
  if (cond) {
    return [item] as T[];
  }
  return [] as T[];
};

export const ifItems = <T>(cond: boolean = false, items: T) => {
  if (cond) {
    return items as T;
  }
  return [] as T;
};

export const toSelectOptions = (data?: Record<string, string>) => {
  return map(data, (label, id) => ({
    id: id,
    label: label as string,
    value: +id,
  }));
};

export const withEmptyCheck =
  <T extends any[], R>(formatter: (...args: T) => R) =>
  (...args: T): R | '' => {
    if (!args[0]) {
      return '' as R | '';
    }
    return formatter(...args);
  };

export const createUniqueID = () => uuidv4();

export const keyToLabel = (value: string) =>
  value.replace(/([a-z])([A-Z])/g, '$1 $2');
